import { createFileRoute } from "@tanstack/react-router";
import { LegalLayout } from "@/components/LegalLayout";
import { useLocale } from "@/contexts/LocaleContext";
import { DICTS } from "@/lib/i18n";
import { PUBLIC_SITE_ORIGIN } from "@/lib/public-origin";

import { publicCacheHeaders } from "@/lib/public-cache-headers";

export const Route = createFileRoute("/cookies")({
  headers: publicCacheHeaders,
  head: () => ({
    meta: [
      { title: DICTS.en["legal.cookies.meta.title"] },
      { name: "description", content: DICTS.en["legal.cookies.meta.description"] },
      { property: "og:title", content: DICTS.en["legal.cookies.meta.title"] },
      { property: "og:description", content: DICTS.en["legal.cookies.meta.description"] },
      { property: "og:url", content: `${PUBLIC_SITE_ORIGIN}/cookies` },
      { property: "og:type", content: "website" },
    ],
    links: [{ rel: "canonical", href: `${PUBLIC_SITE_ORIGIN}/cookies` }],
  }),
  component: CookiesPage,
});

function CookiesPage() {
  const { t } = useLocale();
  return (
    <LegalLayout titleKey="legal.cookies.title" eyebrowKey="legal.cookies.eyebrow">
      <p>{t("legal.cookies.intro")}</p>
      <h2>{t("legal.cookies.h2_essential")}</h2>
      <p>{t("legal.cookies.p_essential")}</p>
      <h2>{t("legal.cookies.h2_analytics")}</h2>
      <p>{t("legal.cookies.p_analytics")}</p>
      <h2>{t("legal.cookies.h2_ads")}</h2>
      <p>{t("legal.cookies.p_ads")}</p>
      <h2>{t("legal.cookies.h2_control")}</h2>
      <p>{t("legal.cookies.p_control")}</p>
    </LegalLayout>
  );
}
